<template>
  <div class="footer-phone">
    <div class="footer-phone-top">
      <span class="special">为您导航 → </span>
    </div>
    <div class="footer-phone-medlie">
      <div class="phone-column">
        <ul>
          <li class="phone-title" @click="goMainPage('solution',1)">解决方案</li>
          <li @click="goToPage('internet',0)">飞联网</li>
          <li @click="goToPage('traveler',1)">飞联网旅客服务</li>
          <li @click="goToPage('airway',2)">飞联网航空公司服务</li>
        </ul>
      </div>
      <div class="phone-column">
        <ul>
          <li class="phone-title" @click="goMainPage('company',2)">关于我们</li>
          <li @click="goAbout(0)">公司简介</li>
          <li @click="goAbout(1)">加入我们</li>
        </ul>
      </div>
      <div class="phone-column">
        <ul>
          <li class="phone-title" @click="goMainPage('home',3)">联系方式</li>
        </ul>
      </div>
    </div>
    <div class="phone-num">
      <img src="../assets/footer-pc/dianhua_yejiao.png" alt="">
      <span class="phone">+86 21-52790110</span>
    </div>
    <div class="phone-bot">© 2020 飞联网（上海）科技有限责任公司版权所有 &ensp; 沪ICP备20012871号</div>
  </div>
</template>

<script>
  export default {
    name: "FooterPhone",
    methods: {
      goToPage (path,index) {
        let params = {
          path,
          index
        };
        this.$store.commit('SET_SOLUTION_PARAMS', params);
        if (this.$route.name === 'solution') return false;
        this.$router.push({name: 'solution'})
      },
      goAbout(index){
        this.$store.commit('SET_COMPANY_INDEX',index);
        this.$store.commit('SET_BANNER_INDEX', 2);
        if (this.$route.name === 'company') return false;
        this.$router.push({name: 'company'});
      },
      goMainPage (name,index) {
        this.$store.commit('SET_BANNER_INDEX', index);
        if (this.$route.name === name) return false;
        this.$router.push({
          name: name
        })
      }
    }
  }
</script>

<style scoped>
  .footer-phone {
    width: 100%;
    background: rgba(38, 45, 61, 1);
    padding: 30px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .footer-phone-medlie {
    margin-top: 20px;
  }

  .special {
    font-size: 20px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(181, 183, 183, 1);
    line-height: 30px;
  }

  .footer-phone-medlie {
    display: flex;
    justify-content: space-between;
  }

  .phone-column {
    font-size: 20px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(138, 142, 142, 1);
    line-height: 30px;
  }

  .phone-column ul li {
    margin-bottom: 20px;
  }

  .phone-column ul li:last-child {
    margin-bottom: 0;
  }

  .phone-title {
    font-size: 22px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: rgba(181, 183, 183, 1);
    line-height: 33px;
  }

  .phone-num {
    display: flex;
    align-items: center;
    font-size: 26px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(181, 183, 183, 1);
    line-height: 39px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .phone-num img {
    width: 24px;
    height: 30px;
    margin-right: 10px;
  }

  .phone-bot {
    font-size: 20px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(138, 142, 142, 1);
    line-height: 30px;
    margin-bottom: 10px;
  }
  .phone-bot:last-child{
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterPhone.vue